import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import DataSourceResource from '../../../DataSource.resource';
export const defaultReducerState = {
    items: getDefaultAsyncWrapperObj(),
};
// Action Types
const prefix = 'loadDataSourceDelete';
export const deleteDataSourceConstants = {
    SetDataSourceDeleteItem: `${prefix}/SetDataSourceDeleteItem`,
};
const loadDeleteDataSourcesArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['items'],
    loadResource: (inputPayload) => {
        return DataSourceResource.deleteDataSource(inputPayload.workspaceId, inputPayload.name);
    },
    onCompleteSuccess: (resourceResult, inputPayload) => {
        return resourceResult;
    },
};
export const loadDeleteDataSourcesEpicReducer = loadResourcesUtils(loadDeleteDataSourcesArgs);
// Reducer
export const dataSourceDeleteReducer = (state = defaultReducerState, action) => {
    state = loadDeleteDataSourcesEpicReducer.reduxChange(state, action);
    if (action.type === deleteDataSourceConstants.SetDataSourceDeleteItem) {
        return {
            ...state,
            items: action.payload,
        };
    }
    return state;
};
// Set dataSourceDelete object
export function SetDataSourceDeleteItem(deleteDataSource) {
    return {
        type: deleteDataSourceConstants.SetDataSourceDeleteItem,
        payload: deleteDataSource.items,
    };
}
export default dataSourceDeleteReducer;

//# sourceMappingURL=DataSourceDelete.ducks.js.map
